import { ImportInstanceDetailCode } from '../enums';
import { IImportErrorColumnRowModel, IImportFileColumnMapping } from '../models';

export function importColumnMapping(column: string, columnsMapping: IImportFileColumnMapping[]): string {
	const mapped = columnsMapping?.find(mapping => mapping.mapsTo === column);
	return mapped ? mapped.columnName : null;
}

export function shouldHaveErrorsExpandedLines(row: IImportErrorColumnRowModel): boolean {
	return row.errorCode !== ImportInstanceDetailCode.None
		&& row.errorCode !== ImportInstanceDetailCode.ExternalStorageConnectionError
		&& row.errorCode !== ImportInstanceDetailCode.ExternalStorageDownloadError
		&& row.errorCode !== ImportInstanceDetailCode.ExternalStorageConfigurationError
		&& row.errorCode !== ImportInstanceDetailCode.ExternalStorageReportError
		&& row.errorCode !== ImportInstanceDetailCode.ExternalStorageGlobalError;
}